import { useApiClient } from "@/src/hooks/useApiClient";

/** Cinq lignes : de quoi voir ce qui presse sans recopier la file entière. */
export const QUEUE_PREVIEW = 5;

/**
 * Une seule ligne suffit à connaître un total.
 *
 * `total` est un `count(*)` sur le statut, indépendant de `limit` — même
 * raisonnement que `useReportCounts`, et c'est ce qui permet d'afficher trois
 * compteurs sans rapatrier trois files.
 */
const COUNT_ONLY = 1;

/**
 * L'état de la file de modération, pour le poste de garde.
 *
 * Trois appels sur le même chemin : la file en attente (les cinq plus anciens,
 * qui sont les plus urgents — le serveur trie du plus ancien au plus récent) et
 * les deux compteurs de ce qui a été tranché.
 *
 * ⚠️ **Pas de `useQueryErrorToast` ici.** Le tableau de bord tire d'un coup sur
 * trois domaines ; un toast par hook en afficherait trois pour une seule panne,
 * au même instant. L'écran n'en lève qu'un (cf. `Dashboard`), et chaque panneau
 * dit lui-même qu'il n'a rien pu lire.
 */
export function useModerationQueue() {
  const $api = useApiClient();

  const queue = $api.useQuery("get", "/api/v1/moderation/reports", {
    params: { query: { status: "pending", limit: QUEUE_PREVIEW } },
  });

  const actioned = $api.useQuery("get", "/api/v1/moderation/reports", {
    params: { query: { status: "actioned", limit: COUNT_ONLY } },
  });

  const dismissed = $api.useQuery("get", "/api/v1/moderation/reports", {
    params: { query: { status: "dismissed", limit: COUNT_ONLY } },
  });

  return {
    /** Les plus anciens en attente : ceux qu'il faut traiter d'abord. */
    reports: queue.data?.data?.reports ?? [],
    // ⚠️ `undefined` tant que le serveur n'a pas répondu, jamais `0` : « aucun
    // signalement » et « on ne sait pas encore » ne se disent pas pareil.
    pending: queue.data?.data?.total,
    actioned: actioned.data?.data?.total,
    dismissed: dismissed.data?.data?.total,
    isLoading: queue.isLoading,
    isError: queue.isError,
    error: queue.error,
  };
}
